<template>
  <div class="hidden lg:flex lg:col-span-3 xl:col-span-2 3xl:col-span-1 bg-slate-900 flex-col overflow-y-auto">
    <div class="text-white flex flex-grow flex-col justify-between">
      <div v-if="agentView === false">
        <div class="mt-4 px-4">
          <router-link
            to="/settings"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Guided Account Setup
          </router-link>
        </div>
        <div class="py-4 px-4">
          <header class="text-white font-bold mb-1">Account</header>
          <router-link
            to="/settings/account/profile"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Profile
          </router-link>
          <router-link
            to="/settings/account/email"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Email
          </router-link>
          <router-link
            to="/settings/account/calendar"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Calendar
          </router-link>
          <router-link
            to="/settings/account/notifications"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Notifications
          </router-link>
        </div>
        <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
          <header class="text-white font-bold mb-1">Company</header>
          <router-link
            to="/settings/company/profile"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Profile
          </router-link>
          <router-link
            to="/settings/company/users"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Users
          </router-link>
          <router-link
            to="/settings/company/billing"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Billing
          </router-link>
          <router-link
            to="/settings/company/scheduling"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Scheduling
          </router-link>
          <router-link
            to="/settings/company/landing_pages"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Landing Pages
          </router-link>
          <router-link
            to="/settings/company/advertising"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Advertising
          </router-link>
          <router-link
            to="/settings/company/onboarding_checklists"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Onboarding Tasks
          </router-link>
          <router-link
            to="/settings/company/offboarding_checklists"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Offboarding Tasks
          </router-link>
          <router-link
            to="/settings/company/training_checklists"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Training Tasks
          </router-link>
        </div>
        <div v-if="$store.state.general.currentUserAccountDetails?.role != 'Contributor'" class="py-4 px-4">
          <header class="text-white font-bold mb-1">Workflows</header>
          <router-link
            to="/settings/workflows/candidate"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Candidate
          </router-link>
          <router-link
            to="/settings/workflows/team"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Team
          </router-link>
        </div>
        <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
          <header class="text-white font-bold mb-1">Data Management</header>
          <router-link
            to="/settings/data/custom_fields"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Custom Fields
          </router-link>
        </div>
        <div v-if="$store.state.general.currentUserAccountDetails.role != 'Contributor'" class="py-4 px-4">
          <header class="text-white font-bold mb-1">Templates</header>
          <router-link
            to="/settings/templates/email"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Email
          </router-link>
          <router-link
            to="/settings/templates/sms"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            SMS
          </router-link>
          <router-link
            to="/settings/templates/esignature"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            E-signature
          </router-link>
        </div>
        <div
          v-if="
            $store.state.general.currentUserAccountDetails.isImpersonated &&
            $store.state.general.currentUserAccountDetails.role == 'Admin'
          "
          class="py-4 px-4"
        >
          <header class="text-white font-bold mb-1">Integrations</header>
          <router-link
            to="/settings/integrations/pandadoc"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            PandaDoc
          </router-link>
          <router-link
            to="/settings/integrations/stripe"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Stripe
          </router-link>
          <router-link
            to="/settings/integrations/telco"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Telco
          </router-link>
          <router-link
            to="/settings/integrations/website"
            class="flex items-center text-slate-300 hover:text-white px-2 py-2 rounded-lg text-sm"
          >
            Website
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    agentView() {
      return this.$store.state.general.currentUserAccountDetails.role === 'Agent';
    },
  },
};
</script>

<!-- duplicated in MobileSidebar -->
<style scoped>
@reference "tailwindcss";
.router-link-exact-active.router-link-active {
  @apply bg-slate-800 font-bold text-white;
}
</style>
